import { render, staticRenderFns } from "./HeaderCards.vue?vue&type=template&id=a16e44fe&lang=pug"
import script from "./HeaderCards.vue?vue&type=script&lang=ts"
export * from "./HeaderCards.vue?vue&type=script&lang=ts"
import style0 from "./HeaderCards.vue?vue&type=style&index=0&id=a16e44fe&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryCard: require('/app/components/parts/CategoryCard.vue').default})
